import { useState, useEffect } from 'react';
import { ref, onValue, off, onChildAdded, onChildChanged, onChildRemoved } from 'firebase/database';
import { database } from '../config/firebase';
import { auth } from '../config/firebase';
import { getUser } from '../utils/Common';
// Hook para escuchar cambios en tiempo real
export const useFirebaseRealtime = (path) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const currentUser = getUser();
        const firebaseUser = auth.currentUser;
        
        if (currentUser && firebaseUser) {
            const expectedUID = currentUser.IdCliente.toString(); 
            if (firebaseUser.uid !== expectedUID) {
                setError(new Error('Usuario no autorizado'));
                setLoading(false);
                return;
            }
        }
        const dataRef = ref(database, path);
        
        const handleData = (snapshot) => {
            try {
                const value = snapshot.val();
                setData(value);
                setLoading(false);
                setError(null);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        const handleError = (error) => {
            setError(error);
            setLoading(false);
        };

        const unsubscribe = onValue(dataRef, handleData, handleError);

        return () => {
            unsubscribe();
        };
    }, [path]);

    return { data, loading, error };
};


